import { AutogenLayoutOfficePayrollHistoryList } from "./autogen/AutogenLayoutOfficePayrollHistoryList";

export class OfficePayrollHistoryList extends AutogenLayoutOfficePayrollHistoryList {
    override onLoad() {
        this.mainDataSource.orderBy = [{ field: "payee_id", sort: "asc" }];
    }
}
